import Ajv from 'ajv';
import * as GarageSubscriptionPassOfferingScheme from './scheme.json';

const ajv = new Ajv();
export const GarageSubscriptionPassOfferingValidator = ajv.compile(
  GarageSubscriptionPassOfferingScheme,
);
